import { DialogPresentation } from "../models/dialog-presentation.model";

export const MOBILE_BOTTOM_SHEET_MEDIA = "(max-width: 999.98px)";

export const MOBILE_SHEET_EXCLUDED_PANEL_CLASSES = ["azm-offcanvas-pane"] as const;

const MOBILE_SHEET_NON_DIALOG_PANEL_CLASSES = [
	"azm-connected-overlay",
	"azm-filter-overlay-pane",
	"azm-datepicker-overlay",
	"azm-tooltip-overlay",
] as const;

export function isMobileBottomSheetViewport(): boolean {
	return typeof matchMedia === "function" && matchMedia(MOBILE_BOTTOM_SHEET_MEDIA).matches;
}

export function normalizeDialogPanelClasses(panelClass: string | string[] | undefined): string[] {
	if (!panelClass) {
		return [];
	}

	if (Array.isArray(panelClass)) {
		return panelClass.flatMap((value) => String(value).split(/\s+/)).filter(Boolean);
	}

	return String(panelClass).split(/\s+/).filter(Boolean);
}

function isExcludedMobileBottomSheetPanel(panelClasses: readonly string[]): boolean {
	return panelClasses.some((panelClass) => (MOBILE_SHEET_EXCLUDED_PANEL_CLASSES as readonly string[]).includes(panelClass));
}

export function shouldUseMobileBottomSheetPanelClass(panelClass: string | string[] | undefined): boolean {
	const classes = normalizeDialogPanelClasses(panelClass);

	if (!isMobileBottomSheetViewport()) {
		return false;
	}

	if (isExcludedMobileBottomSheetPanel(classes)) {
		return false;
	}

	return true;
}

export function withMobileBottomSheetPanelClass(panelClass: string | string[] | undefined): string[] {
	const classes = normalizeDialogPanelClasses(panelClass);

	if (!shouldUseMobileBottomSheetPanelClass(panelClass)) {
		return classes;
	}

	if (classes.includes(DialogPresentation.Sheet)) {
		return classes;
	}

	return [...classes, DialogPresentation.Sheet];
}

export function isMobileBottomSheetPane(pane: HTMLElement): boolean {
	if ((MOBILE_SHEET_NON_DIALOG_PANEL_CLASSES as readonly string[]).some((panelClass) => pane.classList.contains(panelClass))) {
		return false;
	}

	if ((MOBILE_SHEET_EXCLUDED_PANEL_CLASSES as readonly string[]).some((panelClass) => pane.classList.contains(panelClass))) {
		return false;
	}

	if (pane.classList.contains(DialogPresentation.Sheet)) {
		return true;
	}

	if (!isMobileBottomSheetViewport()) {
		return false;
	}

	return pane.querySelector(".cdk-dialog-container") != null;
}
